import {
	configureStore,
	combineReducers,
	getDefaultMiddleware,
} from "@reduxjs/toolkit";

import api from "./middleware/api";

import userReducer from "./User";
import pageReducer from "./Page";
import incompleteChat from "./incompleteChat";
import usStatesReducer from "./usStatesSlice";
import outboundVoiceReducer from "./outboundVoiceSlice";
import trustHubReducer from "./trustHubSlice";
const reducer = combineReducers({
	user: userReducer,
	page: pageReducer,
	incompletechat: incompleteChat,
	usStates: usStatesReducer,
	outboundVoice: outboundVoiceReducer,
  trustHub: trustHubReducer,
});

const store = () => {
	return configureStore({
		reducer,
		middleware: [...getDefaultMiddleware(), api],
	});
};

export default store();
